import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { formatChars, mask } from "./helpers";
import { StyledInput } from "./styles";
import { FormFieldWrapper } from "../../core/shared/FormFieldWrapper";
export function Input({ name, type = "text", value, label, feedback, focusFeedback, loading, hasPermission = true, onValidate, onPressEnter, onDynamicTypeChange, onBlur, onFocus, ...props }) {
    const [feedbackType, setFeedbackType] = useState();
    const [focusFeedbackMessage, setfocusFeedbackMessage] = useState();
    const [dynamicType, setDynamicType] = useState(type);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const commonsProps = {
        name,
        label,
        value,
        feedback: focusFeedbackMessage || feedback,
        ...props,
    };
    const handlePasswordToggle = () => {
        setPasswordVisible((prevState) => {
            const isVisible = !prevState;
            setDynamicType(isVisible ? "text" : type);
            return isVisible;
        });
    };
    const handlePressEnter = () => {
        onPressEnter?.(value);
    };
    const handleOnFocus = () => {
        setfocusFeedbackMessage(focusFeedback);
    };
    const handleClearMessage = () => {
        setTimeout(() => {
            setfocusFeedbackMessage(undefined);
        }, 2000);
    };
    const iconConfigsByType = {
        password: {
            name: passwordVisible ? "visibility_off" : "visibility",
            onClick: handlePasswordToggle,
        },
        search: {
            name: type,
            onClick: handlePressEnter,
        },
    };
    const optionsIconByType = useMemo(() => iconConfigsByType[type] || undefined, [type, passwordVisible]);
    return (_jsx(FormFieldWrapper, { onValidate: onValidate, onChangeFeedback: setFeedbackType, onToggleType: setDynamicType, type: type, loading: loading, rightIcon: optionsIconByType, width: "100%", ...commonsProps, children: _jsx(StyledInput
        // @ts-ignore
        , { 
            // @ts-ignore
            maskChar: null, id: name, type: dynamicType || type, mask: mask(type, value), 
            // @ts-ignore
            formatChars: formatChars(type), onKeyDown: ({ key }) => key === "Enter" && handlePressEnter(), onFocus: (event) => {
                onFocus?.(event);
                handleOnFocus();
            }, onBlur: (event) => {
                onBlur?.(event);
                handleClearMessage();
            }, ...commonsProps, disabled: commonsProps.disabled || !hasPermission, feedback: feedbackType, "data-required": props.required, required: false }) }));
}
//# sourceMappingURL=index.js.map